// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function omitBy<K extends string, T extends Record<K, any>>(
  predicate: (value: T[K]) => boolean,
  object: T
) {
  return Object.fromEntries(
    Object.entries(object).filter(([, value]) => !predicate(value as T[K]))
  ) as Record<keyof T, T[K]>;
}
